import React from 'react';

// CSS filter para colorizar a logo (casco cinza/prata) em cada cor de marca
const BRAND_FILTERS = {
  liquigas:     'grayscale(1) brightness(1.05)',                                        // cinza
  ultragaz:     'sepia(1) saturate(6) hue-rotate(185deg) brightness(0.95)',             // azul
  supergasbras: 'sepia(1) saturate(5) hue-rotate(18deg) brightness(1.05)',              // dourado
  nacional_gas: 'grayscale(1) brightness(1.25) contrast(0.85)',                         // prata
  consigaz:     'sepia(1) saturate(4) hue-rotate(162deg) brightness(1.15)',             // azul claro
};

export default function BrandIcon({ brandId, size = 56 }) {
  const filter = BRAND_FILTERS[brandId] || 'none';
  return (
    <img
      src="/logo.png"
      alt={brandId}
      width={size}
      height={size}
      style={{ filter, objectFit: 'contain' }}
    />
  );
}
